module.exports = __webpack_public_path__ + "media/images/sp/visit_reservations_enpou/flow_01-cb4b59318398953a536a864445f8b686.jpg";